import React from "react";
import "./search-image-slider.css";

/** **Left Nav**
 * -- Search Image-slider 
 * 
 * @param {{
 *  disabled: boolean, 
 *  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void}
 * } props 
 * @returns 
 */
function SliderLeftNav ({disabled, onClick}) {

    return (
        <button 
            aria-label="Previous Slide"
            // aria-hidden="true"
            className="srp-slider-nav-icon srp-slider-nav-button srp-slider-nav-button__left" 
            disabled={disabled}
            onClick={onClick}
            type="button" 
        >
            <svg 
                aria-hidden="true"
                className="srp-slider-nav-icon__svg" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="6 0 12 24" 
                fill="none" 
                focusable={false}
                stroke="currentColor" 
                strokeWidth="1" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            >
                <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
        </button>
    )
}

/** **Right Nav**
 * -- Search Image-slider 
 * 
 * @param {{
 *  disabled: boolean, 
 *  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
 * }} props 
 * @returns 
 */
function SliderRightNav ({disabled, onClick}) {

    return (
        <button 
            aria-label="Next Slide"
            className="srp-slider-nav-icon srp-slider-nav-button srp-slider-nav-button__right" 
            disabled={disabled}
            onClick={onClick}
            type="button" 
        >
            <svg 
                aria-hidden="true"
                className="srp-slider-nav-icon__svg" 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="6 0 12 24" 
                fill="none" 
                focusable="false"
                stroke="currentColor" 
                strokeWidth="1" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            >
                <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
        </button>
    )
}

export {SliderLeftNav, SliderRightNav}